import { styled, ToggleButton, toggleButtonClasses } from "@mui/material";

export const CategorySwitcherButton = styled(ToggleButton)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "calc(var(--spacing)*2)",
  border: "none !important",
  textTransform: "none",
  color: "var(--color-text-primary) !important",
  fontWeight: "400 !important",
  fontSize: "16px",
  letterSpacing: "0.15px",
  lineHeight: "22px",
  borderRadius: "var(--radius-2xl) !important",
  margin: "0 !important",
  padding: "calc(var(--spacing)*2) !important",
  width: "64px",
  [`&.${toggleButtonClasses.selected}`]: {
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "#0000000A",
    },
  },
  [`& svg`]: {
    borderRadius: "var(--radius-2xl)",
    backgroundColor: "var(--color-white)",
    color: "var(--color-text-tertiary)",
    transition: "background-color 0.3s, color 0.3s",
  },
  [`&.${toggleButtonClasses.selected} svg`]: {
    backgroundColor: "var(--color-surface-accent-strong)",
    color: "var(--color-white)",
  },
}));
